import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BaseApiService } from '@carm/_core/baseapi.service';
import {
  ICadMasterProResponse,
  IMPRCCDetailResponse,
} from '../models';
import { tap } from 'rxjs/operators';
import { IBaseResponse } from '@carm/_utils/models';

@Injectable()
export class CadMasterProService extends BaseApiService {

  private readonly masterProvisionalChangeSubject = new BehaviorSubject<IMPRCCDetailResponse>(null);

  constructor(protected injector: Injector) {
    super(injector);
  }

  get cadMprccUrl(): string {
    return `${this.endPointBP}/mp-authorization-request`;
  }

  public get onMasterProvisionalChange$(): Observable<IMPRCCDetailResponse> {
    return this.masterProvisionalChangeSubject.asObservable();
  }

  createMPRCCDraft(): Observable<ICadMasterProResponse> {
    const endPoint = `${this.cadMprccUrl}/draft`;
    return this.httpAuthPost<ICadMasterProResponse>(endPoint, {});
  }

  submitMPRCC(caseId: string): Observable<IBaseResponse> {
    const endPoint = `${this.cadMprccUrl}/draft/${caseId}/submit`;
    return this.httpAuthPost<IBaseResponse>(endPoint, {});
  }

  uploadDocument(): Observable<any> {
    const endpoint = `${this.cadMprccUrl}/upload`;
    return this.httpAuthPost(endpoint, {});
  }

  getMPRCCDetails(serviceRequestId: string): Observable<IMPRCCDetailResponse> {
    const endPoint = `${this.cadMprccUrl}/${serviceRequestId}`;
    return this.httpAuthGet<IMPRCCDetailResponse>(endPoint).pipe(
      tap(response => {
        if (response) {
          this.masterProvisionalChangeSubject.next(response);
        }
      })
    );
  }
}
